import { TaskExplorer } from "./task-explorer";
import type { StatusGroup, TabWindow } from "../../task.types";

type Props = {
  window: TabWindow<StatusGroup>;
};

export const TaskExplorerContainer = ({ window }: Props) => {
  if (!window.state.isOpen) return null;
  if (window.state.isMinimized) return null;

  return <TaskExplorer window={window} />;
};
